import { render, staticRenderFns } from "./SubjectRoles.vue?vue&type=template&id=62bf3044"
import script from "./SubjectRoles.vue?vue&type=script&lang=ts"
export * from "./SubjectRoles.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports